/*
 * Story Theme
 *
 * Keep store-specific JavaScript in this file. The previous content contained
 * invalid CSS inside a JavaScript IIFE and caused a syntax error on every page.
 */

(function () {
  'use strict';
})();
